import { HAObject } from "../HAObject";
import { toMap, toObj } from "../../../HA";

export class HARouter extends HAObject {

    public doGet(data: Map<string, any>): Promise<Map<string, any>> {
        const request = this.createRequest();
        return request.doGet(data.get("url"));
    }

    public post(data: Map<string, any>): Promise<Map<string, any>> {
        const request = this.createRequest();
        return request.post(data.get("url"), data.get("data"));
    }

    protected createRequest() {
        const request = new HTTPRequest();
        this.getRequests().push(request);
        return request;
    }

    protected getRequests() {
        return this.get("requests");
    }

    protected initialize(data?: Map<any, any>) {
        super.initialize(data);
        this.addToData("requests", []);
    }
}

export class HTTPRequest extends HAObject {

    public static createResponse(request: XMLHttpRequest) {
        return new HTTPResponse(request);
    }

    public doGet(url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const request = this.getRequest();
            request.open("GET", url);
            request.onerror = () => reject(new Error("Network error"));
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    resolve(HTTPRequest.createResponse(request).toMap());
                }
            };
            request.send();
        });
    }

    public post(url: string, data?: any): Promise<any> {
        if (data instanceof Map) {
            data.set("ts", Date.now());
            data.set("_sh", screen.height);
            data.set("_sw", screen.width);
            data = toObj(data);
        } else {
            data.ts = Date.now();
            data._sh = screen.height;
            data._sw = screen.width;
        }

        return new Promise((resolve, reject) => {
            const request = this.getRequest();
            request.open("POST", url);
            // CSRF : le serveur (CsrfMiddleware) valide le header X-CSRF-Token sur les
            // méthodes mutantes ; le token est exposé via <meta name="csrf-token">.
            // + sentinelle X-Requested-With (convention forms AJAX HorApp). Doit être
            // posé après open() et avant send().
            const csrf = typeof document !== "undefined"
                ? document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
                : null;
            if (csrf) { request.setRequestHeader("X-CSRF-Token", csrf); }
            request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            request.onerror = () => reject(new Error("Network error"));
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    resolve(HTTPRequest.createResponse(request).toMap());
                }
            };

            if (data instanceof FormData) {
                request.send(data);
            } else {
                request.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
                const urlParameters = Object.keys(data).map((k) => {
                    return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
                }).join("&");
                request.send(urlParameters);
            }
        });
    }

    protected initialize(data?: Map<any, any>) {
        super.initialize(data);
        const request = new XMLHttpRequest();
        this.addToData("request", request);
    }

    protected getRequest(): XMLHttpRequest {
        return this.get("request");
    }
}

export class HTTPResponse extends HAObject {

    public getJSON() {
        const request = this.getRequest();
        try {
            return JSON.parse(request.responseText);
        } catch {
            // Réponse non-JSON (page d'erreur HTML 403/500…) : surfacer le
            // statut au lieu de laisser JSON.parse tuer le handler — les
            // consommateurs (App.findById…) décident du repli.
            return { success: false, _httpStatus: request.status };
        }
    }

    public toMap() {
        return toMap(this.getJSON());
    }

    protected initialize(request: XMLHttpRequest) {
        const data = toMap({request});
        super.initialize(data);
    }

    protected getRequest() {
        return this.get("request");
    }
}

export let Router: HARouter = new HARouter();
